import { reducerWithInitialState } from "typescript-fsa-reducers";
import { loadAuditLog } from "../auditLog/actions";
import { UNAUTHORIZED } from "../constants";
import { loadBriefSpreads, reloadBriefSpreads } from "../documentList/actions";
import { resetUser } from "../login/actions";
import { loadSpread, updateAccount } from "../spread/model/spread/actions";

export interface SessionState {
  authError: boolean;
}

interface Params {
  error: Error;
}

const handleError = (
  sessionState: Readonly<SessionState>,
  { error }: Params
) => ({
  authError: error.message === UNAUTHORIZED
});

const sessionReducer = reducerWithInitialState<Readonly<SessionState>>({
  authError: false
})
  .case(resetUser, () => {
    return {
      authError: false
    };
  })
  .case(loadSpread.async.failed, handleError)
  .case(updateAccount.async.failed, handleError)
  .case(loadBriefSpreads.async.failed, handleError)
  .case(reloadBriefSpreads.async.failed, handleError)
  .case(loadAuditLog.async.failed, handleError);

export default sessionReducer;



// WEBPACK FOOTER //
// ./src/session/reducer.ts